import type React from 'react'

type Props = {
  size?: number
}

const IconReaction: React.FC<Props> = ({ size = 12 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8.625C6.60938 8.625 7.125 9.14062 7.125 9.75C7.125 10.3828 6.60938 10.875 6 10.875C5.36719 10.875 4.875 10.3828 4.875 9.75C4.875 9.14062 5.36719 8.625 6 8.625ZM6 4.875C6.60938 4.875 7.125 5.39062 7.125 6C7.125 6.63281 6.60938 7.125 6 7.125C5.36719 7.125 4.875 6.63281 4.875 6C4.875 5.39062 5.36719 4.875 6 4.875ZM6 3.375C5.36719 3.375 4.875 2.88281 4.875 2.25C4.875 1.64062 5.36719 1.125 6 1.125C6.60938 1.125 7.125 1.64062 7.125 2.25C7.125 2.88281 6.60938 3.375 6 3.375Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconReaction
